import { pick, serverMap } from '@/shared/lib/server-map'

/**
 * Общая палитра `colorKey` → CSS-токен.
 *
 * Контракт использует ДВА разных перечисления с этим смыслом — `Company.colorKey`
 * (`blue|green|orange|violet|gray`, `openapi/components/schemas/session.yaml`) и
 * `PlatformService.colorKey` (`accent|blue|green|orange|violet`,
 * `openapi/components/schemas/platform.yaml`). Они пересекаются на четырёх значениях
 * и расходятся на пятом (`gray` против `accent`) — отдельного типа-перечисления на
 * оба случая контракт не даёт, поэтому таблица ниже держит объединение обоих.
 *
 * Значения — токены из `tokens.css`, не сырые `oklch()`: иначе цвет не сдвигался бы
 * вместе с темой (см. комментарий у `--violet` в tokens.css).
 */
const COLOR_KEY_TOKENS = serverMap({
  blue: 'var(--st-confirmed)',
  green: 'var(--st-in)',
  orange: 'var(--accent)',
  accent: 'var(--accent)',
  violet: 'var(--violet)',
  gray: 'var(--ink-3)',
})

/**
 * `key` типизирован как `string`, а не как объединение обоих перечислений контракта:
 * сервер может отдать значение, которого фронт ещё не знает (контракт расширят раньше,
 * чем перевыпустят фронт) — на рантайме это обычная строка, и полагаться на то, что
 * TypeScript «обещал» одно из пяти значений, нельзя. Незнакомый ключ тихо уезжает в
 * `fallback`, а не роняет аватар и не превращается в `undefined` посреди CSS.
 *
 * Чтение — через общую дверь `pick` (`shared/lib/server-map`): у литерала `Record<string, …>` ключ
 * `toString` вернул бы член `Object.prototype`, и `?? fallback` не сработал бы.
 */
export function colorKeyToken(key: string, fallback: string): string {
  return pick(COLOR_KEY_TOKENS, key, fallback)
}
